export const step5 = {
  initialDate: 'Data de Inicio: ',
  quantityAnimals: 'Nº de animais seguros: ',
  NIF: 'NIF: ',
  policyholderName: 'Nome do Tomador: ',
  secureAnimalsList: 'Lista de animais seguros',
  riskDataAndCover: 'Dados de risco e cobertura',
  sendForQuotationBtn: 'Enviar pedido de cotação',
  acceptConditionsBtn: 'Aceitar condições',
  sendUpdateQuotationButton: 'ENVIAR',
  success: 'Pedido de cotação atualizado com sucesso',
  reportGeneratorBtn: 'Gerar relatório e aceitar',
  crossSell: 'Cross-sell: ',
  campaign: 'Campanha:',
  directDebit: 'Débito Direto: ',
  generalData: 'Dados Gerais',
  tabs: {
    riskData: 'Dados de Risco',
    statements: 'Declarações',
    coverage: 'Cobertura',
    next: 'Avançar',
  },
  riskData: {
    name: 'Nome',
    species: 'Espécie',
    gender: 'Sexo',
    licenseNumber: 'N.º de Licença Camarária',
    birthDate: 'Data de Nascimento',
    breed: 'Raça',
    chipNumber: 'N.º de Chip',
  },
  coverage: {
    mandatory: 'COBERTURAS BASE',
    optional: 'COBERTURAS OPCIONAIS',
  },
  reportAdditional: {
    title: 'Entrega de relatório e documentação obrigatória',
    description:
      'Confirmo que foi entregue a documentação pré-contratual ao Cliente.',
    simulationId: 'ID SIMULAÇÃO ',
    cancel: 'Cancelar',
    continue: 'Confirmar',
  },
  requestAuthorization: {
    title: 'Pedido de Cotação / Autorização',
    agentObservations: 'Observações do Agente',
    comercialStudy: 'Enquadramento / Estudo Comercial',
    coverageDetails: 'Detalhes das Condições / Coberturas',
    relatedEntities: 'Entidades relacionadas (NIF)',
    factorsOther: 'Outros fatores significativos para a apreciação de risco',
    submit: 'SUBMETER PEDIDO',
  },
  quotation: {
    tabs: {
      message: 'Mensagens',
      attachment: 'Anexos',
    },
    sendMessage: 'Enviar mensagem',
    comment: 'Comentário',
  },
}
